import { Component, OnInit } from '@angular/core'
import { ReactiveFormsModule } from '@angular/forms'
import { MatInputModule } from '@angular/material/input'
import { FieldTypeConfig } from '@ngx-formly/core'
import { FieldType } from '@ngx-formly/material'
import { CodeInputModule } from 'angular-code-input'

@Component({
	selector: 'gwc-social-security',
	templateUrl: './social.security.component.html',
	styleUrls: ['./social.security.component.scss'],
	imports: [
		MatInputModule,
		ReactiveFormsModule,
		CodeInputModule
	]
})

export class SocialSecurityComponent extends FieldType<FieldTypeConfig> implements OnInit {
	public code!: string

	ngOnInit(): void {
		this.code = this.formControl.value || ''
	}

	public updateFormControl(code: string): void {
		this.formControl.setValue(code, { emitEvent: true })
	}
}
